import { PanelLeft, PanelLeftClose, PanelRightClose} from "lucide-react";
import { ReactNode, useState } from "react";

type NavbarProps = {
  onToggleSidebar: () => void;
  sidebarOpen: boolean;
  children?: React.ReactNode;
  actions?: ReactNode;
};

function Navbar({ onToggleSidebar, sidebarOpen, actions }: NavbarProps) { 
 
  const [hovered, setHovered] = useState(false);

  return (
      <header className="flex items-center px-4 md:px-6 py-3 border-b border-melt-text1/[.09] bg-white">
      <button
        onClick={onToggleSidebar}
        onMouseEnter={() => setHovered(true)}   
        onMouseLeave={() => setHovered(false)} 
        className="p-2 rounded-md hover:bg-melt-text1/[.05]"
        aria-label="Toggle sidebar"
      >
        {
         
          (() => {
            const Icon = sidebarOpen
              ? (hovered ? PanelLeftClose : PanelLeft)
              : (hovered ? PanelRightClose : PanelLeft);
            return <Icon size={18} className="text-melt-text2" />;
          })()
        }
      </button>
      {/* Right-aligned by default; a page can fill the row (e.g. a title on the left) */}
      {actions ? <div className="ml-3 flex min-w-0 flex-1 items-center justify-end gap-3">{actions}</div> : null}
    </header>
  );
}

export default Navbar;